"use strict";

exports.__esModule = true;
exports.getUniqueTimestamps = void 0;
var getUniqueTimestamps = exports.getUniqueTimestamps = function getUniqueTimestamps(_ref) {
  var data = _ref.data,
    _ref$binName = _ref.binName,
    binName = _ref$binName === void 0 ? "key" : _ref$binName;
  var timestamps = new Set();
  data.map(function (doc) {
    timestamps.add(doc[binName]);
  });
  return Array.from(timestamps).sort();
};